import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './sourcing.intl.json';

export const useSourcingIntl = () => useIntlModule(messages);
